var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"_pbiReport",style:(_vm.reportStyle),attrs:{"id":_vm.id,"width":_vm.width}})])
}
var staticRenderFns = []

export { render, staticRenderFns }